/*
 * Authors: mariushirjanu
 * Created: 31/08/2022
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sso-warning',
  template: `
    <div class="alert alert-warning no-margin-top">
      <i class="fa fa-exclamation-triangle"></i>
      <span>
        This company uses Single Sign-On. The user should sign in via company's <a [href]="urlSSOLogin()">SSO login url</a><br />
        <faq-popup [faqId]="642">Click here for more info</faq-popup>
      </span>
    </div>
  `
})
export class SSOWarningComponent {
  @Input() public urlSSOLogin:Function;
}